export enum POS_REQUEST_ID_LIST {
  GET_POS_CURRENT_STEP = 'GET_POS_CURRENT_STEP',
  PATCH_POS_MENUS = 'PATCH_POS_MENUS',
  GET_POS_FOOD_MENU = 'GET_POS_FOOD_MENU',
  GET_POS_PROVIDER = 'GET_POS_PROVIDER',
  PATCH_UPDATE_POS = 'PATCH_UPDATE_POS',
  POST_MH_STATUS = 'POST_MH_STATUS',
  GET_MENU_MODIFIER_ITEM = 'GET_MENU_MODIFIER_ITEM',
  PATCH_MENU_MODIFIER_ITEM = 'PATCH_MENU_MODIFIER_ITEM',
  PATCH_CANCEL_POS = 'PATCH_CANCEL_POS'
}

export enum POS_STATUS {
  PS01 = 'PS01',
  PS02 = 'PS02',
  PS03 = 'PS03',
  PS04 = 'PS04'
}

export enum BUTTON_FLAG {
  LEAVE_STEP_4 = '-2',
  BACK_ONLY = '-1',
  BACK_AND_SAVE = '0',
  SAVE_ONLY = '1',
  SAVE_AND_NEXT_STEP = '2'
}

export enum POS_STATUS_CODE {
  POS_VERIFIED = 100,
  POS_UNVERIFIED = 101
}

export enum POS_TRANSLATION_KEY {
  NO_MENU  = 'menu_less_than_1',
  PARTIAL_UPDATE = 'partial_update',
  START_DATE_ERROR = 'start_date_error',
  POS_ALREADY_ACTIVATED = 'pos_already_activated',
  SHOP_IN_PROCESS = 'some_shop_in_process',
  MORE_THAN_1_IN_PROCESS = 'more_than_1_in_process'
}

